module.exports = __webpack_public_path__ + "static/media/image-3.298278c5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/depto-nuevo/image-3.jpg
// module id = 256
// module chunks = 0